export default __webpack_public_path__ + "static/media/Tiger's Bracers of the Second Caste.fc5545cc.jpg";